var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.loading)?_c('navbar',{attrs:{"session":_vm.session}}):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('router-view',{staticClass:"view",attrs:{"session":_vm.session}}):_c('div',{staticClass:"loading"},[_c('h1',[_vm._v(_vm._s(_vm.loadingMessage)+_vm._s(_vm.dots))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ba32b18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 